export const tableschema7 = {
    name_table: 'Розділ VII. Відомості про тарифи на харчування(внутрішня статистика)',
    titles:[
        "Тариф на харчування для дітей до 3-х років",
        "Тариф на харчування для дітей до 4-х років",
        "Тариф на харчування для дітей після 4-х років"
      ],
      parts:[
          {title: "Кількісне значення/обране значення", subtitle: "", fields:[
            "FT7000",
            "FT7001",
            "FT7002"
          ]}
      ],
      shorts:{
          titles:[
            "FT7000",
            "FT7001",
            "FT7002"
          ],
          parts:[
              "1"
          ]
      }
};